import m from "../../geodata/es2015/israelPalestineHigh";
window.am4geodata_israelPalestineHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/israelPalestineHigh.js
// module id = null
// module chunks = 